<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="copy">This edition first published in 2022</p>
<p class="copy">by Birlinn Limited</p>
<p class="copy">West Newington House</p>
<p class="copy">10 Newington Road</p>
<p class="copy">Edinburgh</p>
<p class="copy"><span class="small">EH9 1QS</span></p>
<p class="copy1"><em><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></em></p>
<p class="copy1">Copyright © Lilly Hurd 2022</p>
<p class="copy1">The moral right of Lilly Hurd to<br/>be identified as the author of this work<br/>has been asserted by her in accordance<br/>with the Copyright, Designs and<br/>Patents Act 1988</p>
<p class="copy1">Designed and typeset by</p>
<p class="copy">Mark Blackadder</p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="copy"><img alt="Illustration" src="images/pub.jpg"/></p>
<p class="para"> </p>
<p class="copy">Printed and bound by Bell &amp; Bain Ltd, Glasgow</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?08ed1925